import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import Typography from '@mui/material/Typography';
import { useTranslate } from 'react-admin';
import ButtonsBlock from '@/components/common/buttons-block/buttons-block';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';

interface Props {
    onOkClick?: () => void;
    onCancelClick?: () => void;
    isLoading?: boolean;
    open: boolean;
    icon?: any;
    label: string;
}

const ConfirmDialog = ({ onCancelClick, onOkClick, isLoading = false, open, icon, label }: Props) => {
    const translate = useTranslate();

    return (
        <DialogTemplate icon={icon} open={open} onClose={onCancelClick}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                }}
            >
                <Typography>{label}</Typography>

                <ButtonsBlock>
                    <Button onClick={onCancelClick}>{translate('ra.action.cancel')}</Button>

                    <LoadingButton variant={'contained'} onClick={onOkClick} loading={isLoading}>
                        {translate('ra.action.confirm')}
                    </LoadingButton>
                </ButtonsBlock>
            </Box>
        </DialogTemplate>
    );
};

export default ConfirmDialog;
